import { DependencyList, useEffect } from 'react'
import {QCStep} from "~/components/quick-checkout/QuickCheckout.config";

export const STEP_ACTIONS = {
  navigate: 'navigate',
}
export type CustomEventDetail = QCStep['slug']
export const useStepChange = (cb: (event: CustomEvent<CustomEventDetail>) => void, deps: DependencyList) => {
  useEffect(() => {
    window.addEventListener(STEP_ACTIONS.navigate, cb as EventListener)
    return () => {
      window.removeEventListener(STEP_ACTIONS.navigate, cb as EventListener)
    }
  }, [deps])
}
